import { useState, useEffect } from 'react';
import {getTechnicians} from "../../services/Administrative/usersService";

export const useGetTechnician = () => {
    const [technicians, setTechnicians] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchTechnicians = async () => {
            setIsLoading(true);
            try {
                const response: any = await getTechnicians();
                setTechnicians(response);
            } catch (error:any) {
                console.log(error);
            } finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchTechnicians();
    }, []);

    return { technicians, isLoading };
};
